import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledCartCounter = styled.div`
  align-items: center;
  background-color: ${p => p.theme.colors.alert};
  border-radius: 50%;
  color: ${p => p.theme.colors.white};
  display: flex;
  font-size: 0.6875rem;
  height: 20px;
  justify-content: center;
  width: 20px;
`;

export default function CartCounter({ count, className }) {
  if (count && count > 0) {
    return <StyledCartCounter className={className}>{count}</StyledCartCounter>;
  }

  return null;
}

CartCounter.propTypes = {
  count: PropTypes.number.isRequired
};
